jQuery(document).on("page.ready", function () {
  $ = jQuery;

  $(".modal-open").click(function (event) {
    console.log("modal");
    if ($("body").hasClass("modal-active")) {
      // nothing
    } else {
      var $id = $(this).data("id"),
        $modals = $(".modal .container .inner").children();

      $modals.each(function (index, el) {
        console.log("modal", index, el);
        $modalId = $(el).data("id");
        if ($modalId == $id) {
          var $iframe = $(el).children("iframe");
          if ($iframe.hasClass("youtube")) {
            var video = $($iframe).attr("src");

            if (video.includes("youtube")) {
              setTimeout(function () {
                video = video.replace("?autoplay=0", "?autoplay=1");
                $($iframe).attr("src", video);
              }, 800);
            }
          }

          $(el).addClass("active");
        }
      });

      $("body").addClass("modal-active");
    }
  });

  var stopVideos = function () {
    var videos = document.querySelectorAll(".modal iframe, .modal video");
    Array.prototype.forEach.call(videos, function (video) {
      if (video.tagName.toLowerCase() === "video") {
        video.pause();
      } else {
        var src = video.src;
        video.src = src;
      }
    });
  };

  $(".close-modal, .modal").click(function (event) {
    if ($("body").hasClass("modal-active")) {
      var $iframe = $(".modal .content.active").children("iframe");

      if ($iframe.hasClass("youtube")) {
        var video = $($iframe).attr("src");

        if (video.includes("youtube")) {
          video = video.replace("?autoplay=1", "?autoplay=0");
          $($iframe).attr("src", "");
          $($iframe).attr("src", video);
        }
      }

      $("body").removeClass("modal-active");
      $(".modal .container .inner").children().removeClass("active");

      stopVideos();
    } else {
      //nothing
    }
  });
});
